/**
 * Currency symbol by tariff/location code or ISO currency code.
 * Symbols are defined on the frontend; backend often sends enum name only.
 */
const CURRENCY_BY_LOCATION = {
  RU: '₽',   // Russian ruble
  BY: 'Br',  // Belarusian ruble (BYN)
  EE: '€',   // Euro (Estonia)
  AM: '֏',   // Armenian dram
  ID: 'Rp',  // Indonesian rupiah
};

const CURRENCY_BY_CODE = {
  RUB: '₽',
  BYN: 'Br',
  EUR: '€',
  AMD: '֏',
  IDR: 'Rp',
  KZT: '₸',
};

/**
 * @param {string} [location] - Location code (e.g. RU, BY, EE)
 * @returns {string} Currency symbol for display
 */
export function getCurrencySymbolForLocation(location) {
  if (!location || typeof location !== 'string') return '₽';
  const key = location.toUpperCase().trim();
  return CURRENCY_BY_LOCATION[key] ?? CURRENCY_BY_CODE[key] ?? '₽';
}

/**
 * @param {string|{ name?: string, sign?: string }} [currency] - Currency enum name or object
 * @returns {string} Currency symbol for display
 */
export function getCurrencySymbol(currency) {
  if (currency == null) return '₽';
  if (typeof currency === 'object') {
    if (currency.sign) return currency.sign;
    if (currency.name) return getCurrencySymbol(currency.name);
    return '₽';
  }
  const key = String(currency).toUpperCase().trim();
  return CURRENCY_BY_CODE[key] ?? CURRENCY_BY_LOCATION[key] ?? '₽';
}
